import { render, staticRenderFns } from "./serviceInvoice.vue?vue&type=template&id=3c3787ea&scoped=true&"
import script from "./serviceInvoice.vue?vue&type=script&lang=js&"
export * from "./serviceInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3787ea",
  null
  
)

export default component.exports